import React from 'react';
import { Segment, Header, Icon, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <Segment placeholder>
      <Header icon>
        <Icon name='search' />
        ¡Vaya! Hemos buscado por todas partes pero no hemos podido encontrar esto.
      </Header>
      <Segment.Inline>
        <Button as={Link} to='/Inicio' primary>
          Retornar al Inicio
        </Button>
      </Segment.Inline>
    </Segment>
  );
};

export default NotFound;
